import {filter} from "lodash";
import {Icon} from "@iconify/react";
import {sentenceCase} from "change-case";
import {useEffect, useState} from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import {Link as RouterLink, useNavigate} from "react-router-dom";
import moment from "moment";
// material
import {
  Card,
  Button,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  Skeleton,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import {alert} from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import plusFill from "@iconify/icons-eva/plus-fill";
import UserInfo from "src/components/common/UserInfo";
import {asyncRequest} from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserPicker from "src/components/common/UserPicker";
import Cascader from "src/components/cascader/Cascader";
import {useSelector} from "react-redux";
import {getAreas, getDepts} from "src/services/request";
import CityPicker from "src/components/CityPicker";
import Confirm from "src/components/common/ConfirmDialog";

const TABLE_HEAD = [
  {id: "id", label: "ID", alignRight: false},
  {id: "userInfo", label: "联系方式", alignRight: false},
  {id: "level", label: "等级", alignRight: false},
  {id: "area", label: "区域", alignRight: false},
  {id: "pointsV2", label: "积分情况", alignRight: false},
  {id: "payMoney", label: "缴费金额", alignRight: false},
  {id: "status", label: "是否激活", alignRight: false},
  {id: "user", label: "管理员", alignRight: false},
  {id: "createdAt", label: "创建时间", alignRight: false},
  {id: "action", label: "操作"},
];
const moreMenus = [
  {title: "编辑", icon: iconEdit2},
  {title: "删除", icon: iconEdit2},
  // { title: "编辑", icon: iconEdit2 },
];

export default function AgentList() {
  const {areas, areaHierarchy, depts, deptMap} = useSelector((state) => state.globalData);
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [action, setAction] = useState("");
  const [targetItem, setTaretItem] = useState({});
  const [user, setUser] = useState({});
  const [sharer, setSharer] = useState({});

  const [form, setForm] = useState({
    username: "",
    password: "",
    password2: "",
    realname: "",
    payMoney: "",
    roles: [],
    status: 1,
  });

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
    level: null,
    deptId: null,
  });

  useEffect(() => {
    getAreas();
    // getDepts();
  }, []);

  useEffect(() => {
    getItems();
  }, [filter]);

  function handleRefresh() {
    setItems(null);
    getItems();
  }

  async function getItems() {
    const {data, count} = await asyncRequest({
      path: "/agent/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = parseInt(value) - 1;
    console.log(`newPage = %o, filter.page = %o`, newPage, filter.page)
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setTaretItem(row);
      setForm({
        ...row,
        mobile: row.mobile || row.user?.mobile,
      });
      setUser(row.user);
      // setSharer(row.sharer || {});
      setAction("edit");
      // navigate(`/user/edit/${row.uid}`, { state: row });
    } else if (type === "删除") {
      handleDelItem(row.id);
    }
  };

  function handleDelItem(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        const {data} = await asyncRequest({
          path: "/agent/del",
          data: {id},
        });

        getItems();
      },
    });
  }

  // 新增
  function handleAddItem() {
    setAction("add");
    setForm({
      mobile: "",
      realname: "",
      password: "",
      password2: "",
      level: 1,
      status: 1,
    });
    setUser({});
    setSharer({});
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleSelectUser(ki) {
    UserPicker({
      onSelect(val) {
        // console.log(val);
        switch (ki) {
          case "uid":
            setUser(val);
            break;
          case "sharerUid":
            setSharer(val);
            break;
        }
      },
    });
  }

  async function handleDialogConfirm() {
    const {mobile, password, password2, realname, level} = form;
    if (!mobile || !realname) return alert("信息不全");
    if (!user) return alert("请选择用户");
    const formData = {
      ...form,
      uid: user.uid,
    };
    if (action === "edit") {
      formData.id = targetItem.id;
      // } else {
      // if (!password || !password2) return alert("密码必填");
      // if (password !== password2) return alert("两次密码不一致");
    }
    if (form && form.district && form.district.id) {
      formData.provinceId = form && form.province && form.province.id ? form.province.id : '';
      formData.province = form && form.province && form.province.name ? form.province.name : '';
      formData.cityId = form && form.city && form.city.id ? form.city.id : '';
      formData.city = form && form.city && form.city.name ? form.city.name : '';
      formData.districtId = form && form.district && form.district.id ? form.district.id : '';
      formData.district = form && form.district && form.district.name ? form.district.name : '';
    } else {
      formData.provinceId = form && form.provinceId ? form.provinceId : '';
      formData.province = form && form.province ? form.province : '';
      formData.cityId = form && form.cityId ? form.cityId : '';
      formData.city = form && form.city ? form.city : '';
      formData.districtId = form && form.districtId ? form.districtId : '';
      formData.district = form && form.district ? form.district : '';
    }

    if (formData.provinceId && formData.cityId && formData.districtId) {
      const {data} = await asyncRequest({
        path: action === "add" ? "/agent/add" : "/agent/edit",
        data: formData,
      });
      // if (action === "add") {
      //   setItems([...items, data]);
      // } else if (action === "edit") {
      //   const item = items.find((b) => b.uid === targetItem.uid);
      //   Object.assign(item, form);
      //   setItems([...items]);
      // }
      await getItems();
      setAction("");
    } else {
      return alert("请设置准确区域");
    }
  }

  async function handleEditAgent(formData) {
    const {data} = await asyncRequest({
      path: "/agent/edit",
      data: formData,
    });

    getItems();
  }

  return (
    <Page title="代理商列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            代理商列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill}/>} onClick={handleAddItem}>
            添加代理商
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} onRefresh={handleRefresh}>
            <Grid container gap={1}>
              <Grid item sm={6} md={3}>
                <TextField
                  style={{width: 200}}
                  label="用户ID"
                  size="small"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  style={{width: 200}}
                  label="手机号"
                  size="small"
                  placeholder="手机号"
                  autoComplete="off"
                  id="mobile"
                  value={filter.mobile}
                  onChange={(e) => {
                    handleFilterChange("mobile", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl>
                  <InputLabel id="demo-simple-select-label" size="small">
                    等级
                  </InputLabel>
                  <Select
                    // labelId="demo-simple-select-label"
                    // id="demo-simple-select"
                    label="等级"
                    size="small"
                    value={filter.level}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        level: e.target.value,
                      });
                    }}
                    style={{width: 250}}
                  >
                    {[0, 1, 2, 3].map((level, idx) => (
                      <MenuItem key={idx} value={level} name={level}>
                        {/* {idx == 0 ? "全部" : ["街道", "区代", "市代", "省代"][level]} */}
                        {["", "区代", "市代", "省代"][level]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{minWidth: 800}}>
              <Table>
                <ListHead headLabel={TABLE_HEAD}/>
                <TableBody>
                  {!items ? (
                    <TableRow>
                      <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{py: 5}}>
                        <Stack spacing={1} padding={2}>
                          <Skeleton variant="rectangular" animation="wave" height={30}/>
                          <Skeleton variant="rectangular" animation="wave" height={30}/>
                          <Skeleton variant="rectangular" animation="wave" height={30}/>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ) : items.length === 0 ? (
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{py: 5}}>
                        <SearchNotFound searchQuery={filter.search}/>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <>
                      {items.map((row) => {
                        const {
                          id,
                          user,
                          realname,
                          province,
                          city,
                          district,
                          payMoney,
                          mobile,
                          createdAt,
                          pointsV2,
                          lockPointsV2,
                          enableButie,
                          dept,
                          buzhang,
                          dudao,
                          sharer,
                          balance,
                          canWithdraw,
                          level,
                          status
                        } = row;
                        const isItemSelected = selected.indexOf(realname) !== -1;

                        return (
                          <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected}
                                    aria-checked={isItemSelected}>
                            <TableCell align="left">{id}</TableCell>
                            <TableCell
                              align="left">
                              <Stack>
                                <Typography noWrap>
                                  姓名：{realname}
                                </Typography>
                                <Typography noWrap>
                                  电话：{mobile}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">{["", "区代"][level]}</TableCell>
                            <TableCell align="left">
                              {province}
                              {city}
                              {district}
                            </TableCell>
                            <TableCell
                              align="left">
                              <Stack>
                                <Typography noWrap>
                                  锁仓：{lockPointsV2}
                                </Typography>
                                <Typography noWrap>
                                  可用：{pointsV2}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">{payMoney}</TableCell>
                            <TableCell align="left">
                              <Switch checked={status === 1}
                                      onChange={(e) => handleEditAgent({id: row.id, status: status === 1 ? 0 : 1})}/>
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <UserInfo {...user} enablePreview/>
                            </TableCell>
                            <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                            <TableCell align="right">
                              <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)}/>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </>
                  )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange}/>
        </Card>
      </Container>

      <FormDialog title={action === "add" ? "添加代理商" : "修改代理商"} open={!!action}
                  onClose={() => setAction()}
                  onConfirm={handleDialogConfirm}>
        <FormItem title="用户" required sx={{width: 800}}>
          <Stack onClick={() => handleSelectUser("uid")}>
            <UserInfo {...user} enablePreview={false}/>
          </Stack>
        </FormItem>

        <FormItem title="代理" required>
          <Select value={form.level} onChange={(e) => handleIptChange("level", e.target.value)}
                  style={{width: 250, height: 44}}>
            {[0, 1, 2, 3].map((level, idx) => (
              <MenuItem key={idx} value={level} name={level}>
                {["街代", "区代", "市代", "省代"][level]}
              </MenuItem>
            ))}
          </Select>
        </FormItem>

        <FormItem title="区域" required>
          <CityPicker
            level={4 - form.level}
            // code={{provinceId: form.provinceId, cityId: form.cityId, districtId: form.districtId}}
            code={form.districtId}
            onSelect={(val) => {
              console.log(123)
              console.log(val)
              setForm({
                ...form,
                // provinceId: val.province.id,
                // cityId: val.city.id,
                // districtId: val.district.id,
                ...val,
              });
            }}
          />
        </FormItem>

        <FormItem title="手机号" required>
          <TextField placeholder="手机号" autoComplete="off" id="mobile" value={form.mobile} size="small"
                     onChange={(e) => handleIptChange("mobile", e.target.value)}/>
        </FormItem>

        <FormItem title="缴费金额" required>
          <TextField placeholder="缴费金额" autoComplete="off" id="payMoney" value={form.payMoney}
                     size="small"
                     onChange={(e) => handleIptChange("payMoney", e.target.value)}/>
        </FormItem>

        {/* {action === "add" && (
          <>
            <FormItem title="密码" required>
              <TextField placeholder="密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
            </FormItem>

            <FormItem title="密码确认" required>
              <TextField placeholder="密码确认" type="password" autoComplete="off" id="password2" value={form.password2} size="small" onChange={(e) => handleIptChange("password2", e.target.value)} />
            </FormItem>
          </>
        )} */}

        <FormItem title="姓名" required>
          <TextField placeholder="姓名" autoComplete="off" id="realname" value={form.realname} size="small"
                     onChange={(e) => handleIptChange("realname", e.target.value)}/>
        </FormItem>

        {/* <FormItem title="状态" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
            <FormControlLabel value={1} control={<Radio />} label="开启" onChange={(e) => handleIptChange("status", e.target.value)} />
            <FormControlLabel value={0} control={<Radio />} label="关闭" onChange={(e) => handleIptChange("status", e.target.value)} />
          </RadioGroup>
        </FormItem> */}
      </FormDialog>
    </Page>
  );
}
